import RenewalMonitoring from './RenewalMonitoringContainer.vue';

export { RenewalMonitoring };



// WEBPACK FOOTER //
// ./src/modules/home/renewalMonitoring/index.js